import Pagination from "@mui/material/Pagination";
import moment from "moment";
import { useEffect, useRef } from "react";

import EmptyList from "components/EmptyList";
import ListCardSkeleton from "components/ListCardSkeleton";
import { usePatientQuote } from "providers/Quote/PatientQuote";

import PatientQuoteReportCard from "../PatientQuoteReportCard";

const PatientQuoteReportList = () => {
  const patientQuotesReportRef = useRef<HTMLDivElement>(null);
  const patientQuotesReportListRef = useRef<HTMLDivElement>(null);

  const {
    patientConcludedQuotes,
    patientConcludedQuotesTotalPages,
    patientConcludedQuotesCurrentPage,
    isLoadingPatientConcludedQuotes,
    reportSearchData,
    fetchPatientConcludedQuotes,
    setPatientConcludedQuotesCurrentPage,
    setPatientQuotesReportGlobalRef,
  } = usePatientQuote();

  const handlePagination = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setPatientConcludedQuotesCurrentPage(value);

    patientQuotesReportRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  };

  useEffect(() => {
    fetchPatientConcludedQuotes(1);
  }, [reportSearchData]);

  useEffect(() => {
    if (isLoadingPatientConcludedQuotes) return;
    setPatientQuotesReportGlobalRef(patientQuotesReportListRef.current);
  }, [isLoadingPatientConcludedQuotes]);

  return (
    <>
      {!!reportSearchData.beginDate && !!reportSearchData.endDate && (
        <div className="bg-white shadow-sm p-3 rounded-xl mb-3 small">
          <i className="uil uil-calendar-alt me-1" aria-hidden="true" />
          Período: {moment(reportSearchData.beginDate).format("DD/MM/YYYY")}{" "}
          a {moment(reportSearchData.endDate).format("DD/MM/YYYY")}
        </div>
      )}

      {!!isLoadingPatientConcludedQuotes &&
        [...Array(3)].map((_, index) => <ListCardSkeleton key={index} />)}

      {!isLoadingPatientConcludedQuotes && (
        <div ref={patientQuotesReportListRef}>
          {patientConcludedQuotes.length > 0 ? (
            patientConcludedQuotes.map((quote) => (
              <PatientQuoteReportCard key={quote.id} quote={quote} />
            ))
          ) : (
            <EmptyList
              icon="uil-bill"
              title="Nenhum orçamento concluído encontrado"
              subtitle="Ajuste o período ou os filtros para encontrar o que procura"
            />
          )}
        </div>
      )}

      {patientConcludedQuotesTotalPages > 1 && (
        <Pagination
          color="primary"
          size="large"
          hidePrevButton
          hideNextButton
          count={patientConcludedQuotesTotalPages}
          page={patientConcludedQuotesCurrentPage}
          onChange={handlePagination}
          className="mt-4 d-flex justify-content-center"
        />
      )}
    </>
  );
};

export default PatientQuoteReportList;
